import { merchantApiClient } from '../../../../../../redux'
export const GET_MERCHANT_PERFORMANCE_REPORT = '/api/v1/merchant-performance-report'

export const getMerchantPerformanceReport = ({ year, entityName, includeSubAgents }) => {
  return merchantApiClient.get(
    GET_MERCHANT_PERFORMANCE_REPORT + `?year=${year}&entityName=${entityName}&includeSubAgents=${includeSubAgents}`
  )
}
